import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { Logo } from "./Logo";
import { NAV } from "./Navbar";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/5 bg-[#05070B]">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-[1.4fr_1fr_1fr] lg:px-12">
        <div className="space-y-4">
          <Logo testId="footer-logo" />
          <p className="max-w-sm text-sm leading-relaxed text-slate-400">
            We build fast, conversion-focused websites for clients, and we run our own portfolio of web properties with the same playbook.
          </p>
        </div>
        <div>
          <p className="mb-4 font-mono-tech text-xs uppercase tracking-widest text-cyan-400">Navigate</p>
          <ul className="space-y-2">
            {NAV.map((n) => (
              <li key={n.id}>
                <Link to={n.to} data-testid={`footer-link-${n.id}`} className="text-sm text-slate-400 transition-colors hover:text-white">
                  {n.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="mb-4 font-mono-tech text-xs uppercase tracking-widest text-cyan-400">Get in touch</p>
          <a href="mailto:Brent@bealldigitalgroup.com" data-testid="footer-email-link"
            className="inline-flex items-center gap-2 break-all text-sm text-slate-300 transition-colors hover:text-cyan-300">
            <Mail className="h-4 w-4 shrink-0" /> Brent@bealldigitalgroup.com
          </a>
          <p className="mt-3 text-sm text-slate-500">Replies within 1 business day.</p>
        </div>
      </div>
      <div className="border-t border-white/5">
        <p className="mx-auto max-w-7xl px-4 py-6 text-xs text-slate-500 sm:px-6 lg:px-12">
          © {new Date().getFullYear()} Beall Digital Group. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
